<template>
    <div ref="content">
        <vs-row class="mt-4">
            <vs-col sm="12" lg="3">
                <div class="cardLanding">
                    <info ref="infoGeneral" :personaId="personaId" :institucion="institucion" :cicloEscolar="cicloEscolar" :programa="programa" :permisosInfo="permisos" @refreshTable="getCargos"></info>
                </div>
            </vs-col>
            <vs-col sm="12" lg="9">
                <div class="cardLanding">
                    <movimientos :personaId="personaId" :institucion="institucion" :instituciones="instituciones" :institucionId="institucionId" :cicloEscolar="cicloEscolar" :cicloEscolares="cicloEscolares" :cicloEscolarId="cicloEscolarId" :nivel="nivel" :listNivel="listNivel" :nivelId="nivelId" :nivelDefault="nivelDefault" :programa="programa" :programas="programas" :programaId="programaId" :permisos="permisos" :cargo="cargos_parcializados" :loadingCiclo="loadingCiclo" :loadingInstitucion="loadingInstitucion" @scrollTable="scrollMeTo" :refrescar="ejecutar" @refreshCiclo="getCicloDefault" :institucionNivel="listNivel" @refrescarParametros="refreshAll" @ejecutarLoading="getLoading" :ejecutarBalance="ejecutarBalance" :personaRol="personaRol"></movimientos>
                </div>
            </vs-col>
            <div class="mt-5 p-3 cardLanding" ref="porto">
                <div class="d-flex mb-5">
                    <div  @click="getCambioPestana('historial')" :class="estilosCambio == 'historico' ? 'estilosActivos' : 'estilosNoActivos'">
                        <h5>Historial de movimientos</h5>
                    </div>
                    <div  @click="getCambioPestana('conciliacion')" :class="estilosCambio == 'conciliar' ? 'estilosActivos' : 'estilosNoActivos'">
                        <h5>Conciliación bancaria Banamex</h5>
                    </div>
                    <div  @click="getCambioPestana('santander')" :class="estilosCambio == 'santander' ? 'estilosActivos' : 'estilosNoActivos'">
                        <h5>Pagos en línea Santander</h5>
                    </div>
                </div>
                <div v-show="botonHistorial">
                    <historial-movimientos :historial="historial"></historial-movimientos>
                </div>
                <div v-show="botonConciliacion">
                    <vs-row>
                        <vs-col  w="12">
                            <conciliacion :personaId="personaId" :institucion="institucion" :cicloEscolar="cicloEscolar"  :programa="programa" :programas="programas" :programaId="programaId"  @refreshTable="getEjecutar"></conciliacion>
                        </vs-col>
                    </vs-row>
                </div>
                <div v-show="botonSantander">
                    <vs-row>
                        <vs-col  w="12">
                            <santander :santander="santanderData" :institucion="institucion" :cicloEscolar="cicloEscolar" :programa="programa" @refreshTable="postSantanderMovimientos"></santander>
                        </vs-col>
                    </vs-row>
                </div>
            </div>
        </vs-row>
    </div>
</template>

<script>
import info from './info.vue'
import movimientos from './movimientos.vue'
import profesor from '../../../api/requests/landing-profesor'
import conciliacion from './conciliacion.vue'
import Historial from '../landing/historial.vue'
import HistorialMovimientos from './historial.vue'
import Santander from './santander.vue'
export default {
    props:[
        'personaId',
        'personaRol'
    ],
    data(){
        return{
            institucion: '',
            instituciones: [],
            institucionId: (new Date()).getTime(),
            institucionNivel: [],
            cicloEscolar: '',
            cicloEscolares: [],
            cicloEscolarId: (new Date()).getTime(),
            programa: '',
            programas: [],
            programaId: (new Date()).getTime(),
            nivel: '',
            nivelDefault: '',
            listNivel: [],
            nivelId: (new Date()).getTime(),
            permisos: [],
            cargos_parcializados: false,
            ejecutar: 0,
            botonConciliacion: false,
            botonHistorial: true,
            botonSantander: false,
            estilosCambio: 'historico',
            historial: [],
            santanderData: [],
            loadingCiclo: false,
            loadingInstitucion: false,
            loading: null,
            // personaId:''
            ejecutarBalance: 0
        }
    },
    components:{
        info,
        movimientos,
        conciliacion,
        Historial,
        HistorialMovimientos,
        Santander
    },
    created(){
        
        //   const url = window.location.pathname.split('/')
        //   this.personaId = atob(url[3])
        //   console.log(this.personaId)
        this.getInstitucioneDefault()
        this.getPermisos()
    },
    methods:{
        getLoading(estatus){
            if(estatus == true){
                this.loading = this.$vs.loading({
                    target: this.$refs.content,
                })
                return
            }else{
                this.loading.close()
                this.$emit('ejecutarFinanzas', true);
                return
            }
            // this.loading.close()
        },
        refreshAll(ciclo){
            if(ciclo != this.cicloEscolar){
                this.cicloEscolar = ciclo
            }else{
                this.postSantanderMovimientos()
                this.getProgramas()
                this.getLogMovimientos()
                this.getPagosCargos()
                this.ejecutarEp += 1
            }
            // this.postSantanderMovimientosEmit(ciclo)
            // this.getProgramasEmit(ciclo)
            // this.getLogMovimientosEmit(ciclo)
        },
        scrollMeTo(refName, boton) {
            this.botonName = boton
            var element = this.$refs[refName];
            var top = element.offsetTop;

            window.scrollTo(0, top);
            this.getCambioPestana(boton)
        },
        getCambioPestana(boton){
            if(boton == 'conciliacion'){
                this.botonConciliacion = true
                this.botonHistorial = false
                this.botonSantander = false
                this.estilosCambio = 'conciliar'
            }

            if(boton == 'historial'){
                this.botonConciliacion = false
                this.botonHistorial = true
                this.botonSantander = false
                this.estilosCambio = 'historico'
            }

            if(boton == 'santander'){
                this.botonConciliacion = false
                this.botonHistorial = false
                this.botonSantander = true
                this.estilosCambio = 'santander'
            }
        },
        getEjecutar(){
            this.ejecutarBalance += 1
        },
        getCargos(cargo){
            this.cargos_parcializados = cargo
        },
        async getInstitucioneDefault () {
            this.loadingInstitucion = true
             let params = {
                "persona": this.personaId
            }
            const { data: response } = await profesor.getInstitutosDefault(params) || {}
            const { opciones: info, default: val } = response || {}
            this.instituciones = info instanceof Object ?  Object.values(info) : []
            this.institucion = val
            this.idInstitucion = btoa(this.institucion)
            this.institucionId = (new Date()).getTime()
            this.loadingInstitucion = false
        },
        async getCicloDefault(institucion) {
            this.loadingCiclo = true
            let params = {
                "institucion_id": institucion ? institucion : this.institucion,
                "persona_id": this.personaId
            }
            if(institucion){
                this.institucion = institucion
            }
            const { data: response } = await profesor.getCicloDefault(params) || {}
            const { opciones: info, default: val = null } = response || {}
            this.cicloEscolares = info instanceof Object ?  Object.values(info) : []
            this.cicloEscolar = val
            this.cicloEscolarId = (new Date()).getTime()
            this.loadingCiclo = false
            
            const filtrosPadres = {
                institucion: this.institucion,
                cicloEscolar: this.cicloEscolar
            }
            this.$emit('filtroPadres', filtrosPadres)
        },
        async getCicloEmit(institucion) {
            this.cicloEscolar = ''
            this.loadingCiclo = true
            let params = {
                "institucion_id": institucion,
                "persona_id": this.personaId
            }
            this.institucion = institucion
            const { data: response } = await profesor.getCicloDefault(params) || {}
            const { opciones: info, default: val = null } = response || {}
            this.cicloEscolares = info instanceof Object ?  Object.values(info) : []
            this.cicloEscolar = val
            this.cicloEscolarId = (new Date()).getTime()
            this.loadingCiclo = false
            this.getEjecutar() 
        },
        async getProgramas (ciclo) {
            if (this.institucion && this.cicloEscolar){
            let params = {
                institucion_id: this.institucion,
                persona_id: this.personaId,
                ciclo_escolar_id: ciclo ? ciclo : this.cicloEscolar,
            }

            const { data: response } = await profesor.getPrograma(params) || {}
            const { opciones: programas, default:val } = response || {}
                if (programas){
                    this.programas = Object.values(programas)
                    this.programa = val
                    this.programaDefault = val
                    this.programaId = (new Date()).getTime()
                    this.getNivelesAcademicos()
                }
            }
        },
        async getProgramasEmit (ciclo) {
            let params = {
                institucion_id: this.institucion,
                persona_id: this.personaId,
                ciclo_escolar_id: ciclo,
            }

            const { data: response } = await profesor.getPrograma(params) || {}
            const { opciones: programas, default:val } = response || {}
                if (programas){
                    this.programas = Object.values(programas)
                    this.programa = val
                    this.programaDefault = val
                    this.programaId = (new Date()).getTime()
                    this.getNivelesAcademicos()
                }
        },
        async getNivelesAcademicos () {
            if (this.programa){
                let params = {
                programa: this.programa,
                institucion: this.institucion,
                }
                const { data: response } = await profesor.getNivel(params) || {}
                const { opciones: niveles, default: val } = response || {}
                if (niveles){
                    this.listNivel =  Object.values(niveles)
                    this.nivel = val
                    this.nivelDefault = val
                    this.nivelId = (new Date()).getTime()
                    this.nivelInfo = {
                        listNivel: this.listNivel,
                        nivel: this.nivel,
                        nivelId: this.nivelId
                    }
                    this.ejecutarBalance += 1
                    
                }
            }
        },
        // async getNivelInstitucion(){
        //     console.log("entro a get")
        //     try{
        //     const {data: response} = await profesor.getNivelInstitucion(this.institucion)
        //     this.institucionNivel =  Object.values(response)
        //     console.log(this.institucionNivel)
        //     } catch{

        //     }
        // },
        async getPermisos () {
            try {
                const params = {
                    "seccion" : 'gestion_finanzas'
                    }
                const { data: perm } = await profesor.getPermisosSeccion(params)
                if (perm instanceof Object){
                    this.permisos = perm.permisos
                }
            } catch (error) {
                console.log(error)
            }            
        },
        async getLogMovimientos(){
            if(this.cicloEscolar){
                try {
                    const params = {
                        "ciclo_escolar_id" : this.cicloEscolar,
                        "institucion_id": this.institucion,
                        "persona_id": this.personaId
                        }
                    const { data: response } = await profesor.getLogMovimientos(params)
                    this.historial = response
                } catch (error) {
                    console.log(error)
                }
            }
        },
        async getLogMovimientosEmit(ciclo){
            this.historial =  []
            try {
                const params = {
                    "ciclo_escolar_id" : ciclo,
                    "institucion_id": this.institucion,
                    "persona_id": this.personaId
                    }
                const { data: response } = await profesor.getLogMovimientos(params)
                this.historial = response
            } catch (error) {
                console.log(error)
            }
        },
        async postSantanderMovimientos(){
            const formData = new FormData();
            formData.append("persona_id", this.personaId)
            formData.append("ciclo_escolar_id", this.cicloEscolar)
            formData.append("institucion_id", this.institucion)

            const { data: response } = await profesor.postSantanderMovimientos(formData) || {}
            this.santanderData = response
        },
        async postSantanderMovimientosEmit(ciclo){
            const formData = new FormData();
            formData.append("persona_id", this.personaId)
            formData.append("ciclo_escolar_id", ciclo)
            formData.append("institucion_id", this.institucion)

            const { data: response } = await profesor.postSantanderMovimientos(formData) || {}
            this.santanderData = response
        },
        async getPagosCargos(ciclo){
            await new Promise(r => setTimeout(r, 100))
            try {
                // this.cicloEscolar = ciclo
            } catch (error) {
                loading.close()
                console.log(error)
            }
        },
    },
    watch:{
        personaId(){
            this.getInstitucioneDefault()
        },
        institucion(){
            this.getCicloDefault()
            // this.getNivelInstitucion()
            this.ejecutarEp += 1
        },
        cicloEscolar(){
            this.postSantanderMovimientos()
            this.getProgramas()
            this.getLogMovimientos()
            this.getPagosCargos()
            this.ejecutarEp += 1
        },
        // programa(){
        //     this.getNivelesAcademicos()
        // }
    }
}
</script>

<style scoped>
.estilosActivos{
    color:#2471A3;
    border-bottom: 2px solid #2471A3;
    font-weight: bold;
    margin: 0 1%;
    cursor: pointer;
}
.estilosNoActivos{
    color:#CACFD2;
    font-weight: bold;
    margin: 0 1%;
    cursor: pointer;
}
</style>

